// REACT & Libraries
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import DataTable from "react-data-table-component";
import FilterComponent from "../../Common/FilterComponent";

// Table
import { CityTableColumn } from "../../../../Data/DataTables/City";

// Types
import { ViewCity } from "../../../../Types/MasterData/City";

// Services
import {
  VIEW_CITY_QUERY_KEY,
  cityService,
} from "../../../../Services/cityService";

const CityTable = () => {
  const [filterText, setFilterText] = useState("");
  const { data: dataResponse, isLoading } = useQuery({
    queryKey: VIEW_CITY_QUERY_KEY,
    queryFn: cityService.getAllCities,
  });

  const filteredItems: ViewCity[] =
    dataResponse?.filter((item: ViewCity) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
    ) ?? [];

  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  return (
    <>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={CityTableColumn}
          striped={true}
          pagination
          progressPending={isLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default CityTable;
